import React from "react";
import { useFormikContext } from "formik";
import useAxios from "axios-hooks";
import { Image, Spinner, Stack } from "@fluentui/react";
import TextField from "../Forms/TextField";
import UploadButton from "../Forms/UploadButton";

const ImagePreviewUpload = ({ 
  id, idType, uploadUrl, previewUrl, name, label, width, height, cdnPath, helpMsg, cdnUrl, btnText = 'Upload Image', altName, altLabel
}) => {
  const { setFieldValue } = useFormikContext();
  const [{ loading }, postImage] = useAxios(
      { url: uploadUrl, method: "post", headers: { 'content-type': 'multipart/form-data' }},
      { manual: true }
  );

  const uploadImage = async (file) => {
      const data = new FormData();
      data.append("Image", file);
      data.append(idType, id);
      data.append("Path", cdnPath)
      const response = await postImage({ data });
      if (response.status === 200 && cdnPath && file.name) {
        const url = cdnUrl + cdnPath + file.name.replaceAll(" ", "-");
        setFieldValue(name, url);
      }
  };

  if (loading) {
    return <Spinner className="absolute-center" text="Uploading..." />;
  }

  return (
      <Stack>
          <TextField label={label} name={name} />
          {helpMsg && <label className='preview-upload-help'>{helpMsg}</label>}
          {previewUrl && <Image src={previewUrl} width={width} height={height} />}
          <div className='preview-upload-btn'>
            <UploadButton
              name={`${name}Uploader`}
              accept="image/*"
              label={btnText}
              onChange={(e) => {
                  if (e.target.files?.length) {
                      uploadImage(e.target.files[0]);
                  }
              }}
            />
          </div>
          {altName && <TextField label={altLabel} name={altName} required />}
      </Stack>
  );
};

export default ImagePreviewUpload;
